import { useState } from 'react';
import cn from 'classnames';
import Button from '@creditflowresearch/uilib/Button';
import Menu, { MenuItem, MenuItemType } from '@creditflowresearch/uilib/Menu';
import IconFileXls from '@creditflowresearch/uilib/Icon/IconFileXls';
import styles from './bondScreenerExportButton.module.scss';

interface IBondScreenerExportButtonProps {
  dataTest: string,
  onExportAll: () => void,
  onExportSelected?: () => void,
  showDropdown?: boolean,
  isDisabled?: boolean,
  isLoading?: boolean,
}

const BondScreenerExportButton = ({
  dataTest,
  onExportAll,
  onExportSelected,
  showDropdown = false,
  isDisabled = false,
  isLoading = false,
}: IBondScreenerExportButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const isBlocked = isDisabled || isLoading;

  const handleExportAll = (): void => {
    onExportAll();
    setIsOpen(false);
  };

  const handleExportSelected = (): void => {
    onExportSelected?.();
    setIsOpen(false);
  };

  const handleSetOpen = (open: boolean): void => {
    if (open && isBlocked) return;
    setIsOpen(open);
  };

  if (!showDropdown) {
    return (
      <Button
        dataTest={ dataTest }
        variant="outline"
        size="S"
        className={ cn({ [styles.active]: isOpen }) }
        icon={ <IconFileXls /> }
        ariaLabel="Export"
        disabled={ isDisabled }
        loading={ isLoading }
        onClick={ handleExportAll }
      />
    );
  }

  return (
    <Menu
      trigger={ ({ referenceProps }) => (
        <Button
          { ...referenceProps }
          dataTest={ dataTest }
          variant="outline"
          size="S"
          className={ cn({ [styles.active]: isOpen }) }
          icon={ <IconFileXls /> }
          ariaLabel="Export"
          disabled={ isDisabled }
          loading={ isLoading }
        />
      ) }
      placement="bottom-end"
      open={ isOpen }
      setOpen={ handleSetOpen }
      usePortal={ false }
      disabled={ isBlocked }
      dataTest={ `${ dataTest }Dropdown` }
      contentClassName={ styles.dropdownContent }
      returnFocusOnClose
      initialFocus="firstItem"
    >
      <MenuItem
        type={ MenuItemType.button }
        dataTest={ `${ dataTest }ExportAll` }
        onClick={ handleExportAll }
        disabled={ isBlocked }
      >
        Export all columns
      </MenuItem>
      <MenuItem
        type={ MenuItemType.button }
        dataTest={ `${ dataTest }ExportSelected` }
        onClick={ handleExportSelected }
        disabled={ !onExportSelected || isBlocked }
      >
        Export selected columns
      </MenuItem>
    </Menu>
  );
};

export default BondScreenerExportButton;
